<template>

    <input type="text" v-model="selectedValue" v-on:keypress="checkValue" />

</template>

<script>

    export default {
        name: 'number-input-component',
        props: {
            'mode': { type: String } //int vs double type allowed
        },
        data: function () {
            return {
                selectedValue: null,
                lastGoodNumber: null
            };
        },
        watch: {

            selectedValue: function (newValue, oldValue) {

                //'.' is a nan = true... need to guard against it

                //is this a real number?
                if (newValue != '.' && isNaN(newValue)) {
                    this.selectedValue = this.lastGoodNumber;
                }
                else {
                    this.lastGoodNumber = newValue;
                    this.$emit('input', newValue);
                }
            }
        },
        computed: {

            patternToValidate: function () {
                return this.mode == 'int' ?
                    "[0-9]" :
                    "[0-9.]";
            }

        },
        methods: {

            checkValue: function (event) {

                //make sure its a valid character. Then check if there is already a "." character
                if (!new RegExp(this.patternToValidate).test(event.key) || (event.key == '.' && this.selectedValue && this.selectedValue.indexOf('.') != -1)) {
                    //don't do anything
                    event.preventDefault();
                }
            }

        }
    };
</script>
